import { useLocalStorage, usePreferredDark } from "@vueuse/core";
import { computed, watchEffect } from "vue";

export type ThemeChoice = "light" | "dark" | "system";

/**
 * Theme state. `system` follows the OS; an explicit choice stamps
 * `data-theme` on the root, which the tokens give precedence over the media
 * query — in both directions.
 */
export function useTheme() {
	const choice = useLocalStorage<ThemeChoice>("bx.theme", "system");
	const prefersDark = usePreferredDark();

	const resolved = computed<"light" | "dark">(() =>
		choice.value === "system" ? (prefersDark.value ? "dark" : "light") : choice.value,
	);

	watchEffect(() => {
		const root = document.documentElement;
		if (choice.value === "system") root.removeAttribute("data-theme");
		else root.setAttribute("data-theme", choice.value);
	});

	// Two states only (dono, 29/10): `system` stays as the first-visit default, never a stop.
	function cycle(): void {
		choice.value = resolved.value === "dark" ? "light" : "dark";
	}

	return { choice, resolved, cycle };
}
